
(function ($) {
    "use strict";
    $(function () {



        $(".js-contact-form").on("submit", function (e) {
            e.preventDefault();
            var $this = $(this);

            $this.find(".js-form-submit").prop("disabled", true);

            var formdata = $this.serializeArray();

            $.ajax({
                url: localize.ajaxurl,
                type: 'POST',
                data: {
                    action: "contact_form",
                    datas: formdata
                },
                success: function (data) {
                    var result = JSON.parse(data)

                    if ($('#info-modal').length) {
                        $('#info-modal').iziModal('destroy');
                    }

                    $("#info-modal").iziModal({
                        title: result["title"],
                        subtitle: result["message"],
                        headerColor: (result['status'] == 'success') ? '#00af66' : '#CE1F3F',
                        width: 600,
                        timeout: 5000,
                        timeoutProgressbar: true,
                        transitionIn: 'fadeInDown',
                        transitionOut: 'fadeOutDown',
                        pauseOnHover: true,
                        autoOpen: true,
                        radius: 0,
                    });

                    if (result['status'] == 'success') {
                        $this.trigger('reset');
                    }

                }
            }).done(function (response) {
                $this.find(".js-form-submit").prop("disabled", false);
            });
        });





    });
})(jQuery);